import AlertError from '@/assets/icons/alert-error.svg?react';
import AlertSuccess from '@/assets/icons/alert-success.svg?react';

export const AlertErrorIcon = () => <AlertError />;
export const AlertSuccessIcon = () => <AlertSuccess />;

export const alertErrorIcon = AlertErrorIcon();
export const alertSuccessIcon = AlertSuccessIcon();
